import React from 'react';

import { composeClassName } from '@/utils/util_helpers';

import { GetOutgoingTransactionsListContextProvider } from './hooks/use-get-outgoing-transactions';
import { OutgoingTransactionsListTable } from './components/outgoing-transactions-list-table';
import { GetOutgoingTransactionsListFilterContextProvider } from './hooks/use-get-outgoing-transactions-list-filter';
import { OutgoingTransactionsListFilterContainer } from './components/outgoing-transactions-list-filter-container';
import { GetOutgoingTransactionPaymentContextProvider } from './hooks/use-get-outgoing-transaction-payment';
import { CancelOutgoingTransactionContextProvider } from './hooks/use-cancel-outgoing-transaction';
const OutgoingTransactionsListContent = () => {
  return (
    <div className={composeClassName('flex h-full w-full flex-1 flex-col')}>
      <OutgoingTransactionsListFilterContainer />
      <OutgoingTransactionsListTable />
    </div>
  );
};

const PayoutsList = () => {
  return (
    <GetOutgoingTransactionsListFilterContextProvider>
      <GetOutgoingTransactionsListContextProvider>
        <GetOutgoingTransactionPaymentContextProvider>
          <CancelOutgoingTransactionContextProvider>
            <OutgoingTransactionsListContent />
          </CancelOutgoingTransactionContextProvider>
        </GetOutgoingTransactionPaymentContextProvider>
      </GetOutgoingTransactionsListContextProvider>
    </GetOutgoingTransactionsListFilterContextProvider>
  );
};

export { PayoutsList };
